var map = {
	"./a.conf": 27,
	"./b.conf": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;


//////////////////
// WEBPACK FOOTER
// ./src/scripts/config ^\.\/.*\.conf$
// module id = 26
// module chunks = 1